/* eslint-disable unicorn/prefer-top-level-await */
// https://github.com/colinhacks/zod?tab=readme-ov-file#catch

import { z } from 'zod'
import { catchWithSentryCapture } from '../utils'

export const listParameterSchema = z
  .union([z.array(z.string()), z.string().transform((value) => [value])])
  .optional()
  .default([])
  .catch(catchWithSentryCapture([], 'listParameterSchema'))
